var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackArrow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.9994 14.667H7.21806L14.2754 7.60966C14.4015 7.48635 14.5018 7.33926 14.5707 7.1769C14.6395 7.01453 14.6755 6.84013 14.6764 6.66378C14.6774 6.48743 14.6434 6.31264 14.5763 6.14953C14.5093 5.98643 14.4106 5.83824 14.2858 5.71355C14.1611 5.58886 14.0129 5.49015 13.8498 5.42313C13.6867 5.35612 13.5119 5.32212 13.3355 5.32312C13.1592 5.32413 12.9848 5.36011 12.8224 5.42897C12.6601 5.49784 12.513 5.59822 12.3897 5.72432L3.0564 15.0577C2.80644 15.3077 2.66602 15.6468 2.66602 16.0003C2.66602 16.3539 2.80644 16.693 3.0564 16.943L12.3897 26.2763C12.5134 26.4004 12.6604 26.4988 12.8222 26.5658C12.9841 26.6328 13.1576 26.6672 13.3327 26.667C13.5964 26.6669 13.8541 26.5887 14.0733 26.4422C14.2926 26.2957 14.4634 26.0875 14.5643 25.8439C14.6652 25.6003 14.6916 25.3322 14.6402 25.0736C14.5888 24.815 14.4618 24.5775 14.2754 24.391L7.21806 17.3337H27.9994C28.353 17.3337 28.6922 17.1932 28.9422 16.9431C29.1923 16.6931 29.3327 16.3539 29.3327 16.0003C29.3327 15.6467 29.1923 15.3076 28.9422 15.0575C28.6922 14.8075 28.353 14.667 27.9994 14.667Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackArrow);
export default __webpack_public_path__ + "static/media/back-arrow.ea88564d889345d16425fd4739b710ed.svg";
export { ForwardRef as ReactComponent };